import { FareInterface } from '../fares/types';
import { LineSectionBaseInterface } from '../lines/types';
import { ProfileInterface } from '../profiles/types';

/*
 * Action Types
 */
export enum FareBonusTypes {
  LIST_FARE_BONUS_REQUEST = '@fareBonus/LIST_FARE_BONUS_REQUEST',
  LIST_FARE_BONUS_SUCCESS = '@fareBonus/LIST_FARE_BONUS_SUCCESS',
  LIST_FARE_BONUS_FAILURE = '@fareBonus/LIST_FARE_BONUS_FAILURE',

  GET_FARE_BONUS_REQUEST = '@fareBonus/GET_FARE_BONUS_REQUEST',
  GET_FARE_BONUS_SUCCESS = '@fareBonus/GET_FARE_BONUS_SUCCESS',
  GET_FARE_BONUS_FAILURE = '@fareBonus/GET_FARE_BONUS_FAILURE',

  FILTER_FARE_BONUS_REQUEST = '@fareBonus/FILTER_FARE_BONUS_REQUEST',
  FILTER_FARE_BONUS_SUCCESS = '@fareBonus/FILTER_FARE_BONUS_SUCCESS',
  FILTER_FARE_BONUS_FAILURE = '@fareBonus/FILTER_FARE_BONUS_FAILURE',

  CREATE_FARE_BONUS_REQUEST = '@fareBonus/CREATE_FARE_BONUS_REQUEST',
  CREATE_FARE_BONUS_SUCCESS = '@fareBonus/CREATE_FARE_BONUS_SUCCESS',
  CREATE_FARE_BONUS_FAILURE = '@fareBonus/CREATE_FARE_BONUS_FAILURE',

  UPDATE_FARE_BONUS_REQUEST = '@fareBonus/UPDATE_FARE_BONUS_REQUEST',
  UPDATE_FARE_BONUS_SUCCESS = '@fareBonus/UPDATE_FARE_BONUS_SUCCESS',
  UPDATE_FARE_BONUS_FAILURE = '@fareBonus/UPDATE_FARE_BONUS_FAILURE',

  DELETE_FARE_BONUS_REQUEST = '@fareBonus/DELETE_FARE_BONUS_REQUEST',
  DELETE_FARE_BONUS_SUCCESS = '@fareBonus/DELETE_FARE_BONUS_SUCCESS',
  DELETE_FARE_BONUS_FAILURE = '@fareBonus/DELETE_FARE_BONUS_FAILURE',
}

/*
 * Data types
 */

export interface FareBonusForm {
  name?: string;
  active?: boolean | null;
  description?: string;
  startDate?: Date | null;
  startTime?: Date | null;
  updateRequest?: Array<any>;
  changesByPeriod?: Array<any>;
  operation?: string;
  discountType?: string | number;
  discountValue?: string | number;
  allLineSections?: boolean | null;
  fares?: Array<any>;
  carFares?: Array<any>;
  lines?: Array<any>;
  profiles?: Array<any>;
  weekdays?: Array<any>;
}

export interface FareBonusDayElement {
  id: string;
  day?: string;
  createdAt: Date;
  updatedAt: Date;
  fareBonusId: string;
  fareId?: null | string;
  lineSectionId?: string;
}

export interface FareBonusPeriod {
  id: string;
  start: string;
  end: string;
  createdAt: Date;
  updatedAt: Date;
  fareBonusId: string;
}

export interface FareBonusProfile {
  id: string;
  applyFareBonus: boolean;
  applyBenefit: boolean;
  applyFareFirst: boolean;
  createdAt: Date;
  updatedAt: Date;
  fareBonusId: string;
  profileId: string;
  Profile: ProfileInterface;
}

export interface FareBonusUpdateRequest {
  id: string;
  data: string;
  description: string;
  validFrom: Date;
  updated: boolean;
  createdAt: Date;
  updatedAt: Date;
  fareBonusId: string;
}

export interface FareBonusInterface {
  id: string;
  name: string;
  status: number;
  type: number;
  valueType: string;
  value: number;
  createdAt: Date;
  updatedAt: Date;
  transportOperatorId: string;
  FareBonusDays?: FareBonusDayElement[];
  FareBonusPeriods?: FareBonusPeriod[];
  FareBonusProfiles?: FareBonusProfile[];
  FareBonusUpdateRequests?: FareBonusUpdateRequest[];
  Fares?: FareInterface[];
  CarFares?: FareInterface[];
  LineSections?: LineSectionBaseInterface[];
}

/*
 * State type
 */
export interface FareBonusState {
  readonly fareBonusList: FareBonusInterface[];
  readonly fareBonusData: FareBonusInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
